import React, { useEffect, useState } from "react";
import func from "./functionAdd";
import json from "../json.json";
import Boxes from "./Boxes";

export default function Contact() {
  // Estado para los campos del formulario
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    title: "app",
    message: "",
  });

  // Estado para gestionar errores en la validación (los errores se muestran inline)
  const [formErrors, setFormErrors] = useState({});

  // Estado para el idioma (true para En, false para Es o viceversa, según tu lógica)
  const [language, setLanguage] = useState(true);

  // Estado para el manejo del modal; usaremos un único tipo de mensaje para validación.
  const [modalState, setModalState] = useState({
    visible: false,
    type: "", // "success", "error" o "validationError"
  });

  // useEffect para leer el idioma del localStorage al montar el componente
  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    // Si storedLanguage es "true", asigna false; sino true (ajusta esta lógica según tu necesidad)
    setLanguage(storedLanguage === "true" ? false : true);
  }, []);

  // Manejo de cambios en los campos (componente controlado)
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Función de validación: valida cada campo y el email usando una expresión regular.
  const validateForm = () => {
    const errors = {};

    if (!formValues.name.trim()) {
      errors.name = language
        ? "Name is required"
        : "El nombre es obligatorio";
    }

    if (!formValues.email.trim()) {
      errors.email = language
        ? "Email is required"
        : "El correo es obligatorio";
    } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
      errors.email = language
        ? "Email is invalid"
        : "El correo es inválido";
    }

    if (!formValues.title.trim()) {
      errors.title = language
        ? "Title is required"
        : "El título es obligatorio";
    }

    if (!formValues.message.trim()) {
      errors.message = language
        ? "Message is required"
        : "El mensaje es obligatorio";
    }

    return errors;
  };

  // Función para decodificar secuencias Unicode en una cadena (solución temporal en el frontend)
  // Nota: Esta solución se basa en aprovechar JSON.parse, pero lo ideal es corregir la codificación en el backend.
  const decodeUnicode = (str) => {
    try {
      return JSON.parse(`"${str}"`);
    } catch (err) {
      return str;
    }
  };

  // Manejo del envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);

    // Si existen errores, mostramos el modal con un mensaje único de validación.
    if (Object.keys(errors).length > 0) {
      setModalState({ visible: true, type: "validationError" });
      return;
    }

    // Preparar los parámetros. Se limpian comas para evitar problemas.
    let messageToSend = formValues.message;
    // Si el mensaje contiene secuencias Unicode escapadas, se podría decodificar:
    // (aunque normalmente el usuario escribe bien los acentos, lo que se muestra con \u00e1
    // indica un tema de codificación en el backend)
    messageToSend = decodeUnicode(messageToSend);

    const params = {
      name: formValues.name.replace(/,/g, ""),
      message: messageToSend.replace(/,/g, ""),
      sendto: formValues.email.replace(/,/g, ""),
      title: formValues.title,
    };

    try {
      await func.EjectFetch("apimailer/index.php", params);
      setModalState({ visible: true, type: "success" });
      // Limpiamos el formulario tras el envío exitoso
      setFormValues({
        name: "",
        email: "",
        title: "app",
        message: "",
      });
      setFormErrors({});
    } catch (error) {
      // Si ocurre un error en el envío, mostramos un modal de error (por ejemplo "modal3")
      setModalState({ visible: true, type: "error" });
    }
  };

  return (
    <>
      {modalState.visible && (
        <Boxes
          setOnModal={(visible) =>
            setModalState((prev) => ({ ...prev, visible }))
          }
          type={modalState.type}
          data={""}
        />
      )}
      <section className="contenido">
        <article className="info-img">
          <div className="informacion-header">
            <h1 className="header-titulo">
              {language ? json.En.headerTitleContact : json.Es.headerTitleContact}
            </h1>
            <h3 className="subtitulo-header">
              {language
                ? json.En.headerSubtitleContact
                : json.Es.headerSubtitleContact}
            </h3>
            <p className="texto-header">
              {language
                ? json.En.headerTextContact
                : json.Es.headerTextContact}
            </p>
          </div>
          <div className="imagen-h">
            <img
              src="css/images/img-header-contacto_.png"
              className="image-head"
              style={{ width: "70%" }}
              alt="walliacontacto"
            />
          </div>
        </article>
        <section className="contacto-datos">
          <article className="cajas-contacto">
            <article className="box-contact-datos">
              <p className="subtitle-contact">
                {language
                  ? json.En.articleSubtitleContact
                  : json.Es.articleSubtitleContact}
              </p>
              <p className="text-contact-datos">
                {language
                  ? json.En.articleTextContact
                  : json.Es.articleTextContact}
              </p>
              <p className="datos">
                <img
                  src="css/images/foot-phone_.png"
                  className="icon-datos"
                  alt="walliaphone"
                />
                +1 786 493 9995
              </p>
              <p className="datos">
                <img
                  src="css/images/foot-phone_.png"
                  className="icon-datos"
                  alt="walliaphone"
                />
                +52 55 5504 7563
              </p>
              <p className="datos">
                <img
                  src="css/images/foot-mail_.png"
                  className="icon-datos"
                  alt="walliamail"
                />
                contact@wallia.io
              </p>
              <p className="datos">
                <img
                  src="css/images/icon-pin-wallia-c.png"
                  className="icon-datos"
                  alt="walliapin"
                />
                MÉXICO - LATAM - USA
              </p>
              <img src="css/images/mapa-gris_.png" className="map" alt="" />
            </article>
            <article className="box-contact-datos">
              <article className="form-fondo">
                <form
                  className="form-contact-datos"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="campo-datos">
                    <label htmlFor="name" className="label-contact-datos">
                      {language ? json.En.name : json.Es.name}
                    </label>
                    <br />
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="campo-contact-datos"
                      value={formValues.name}
                      onChange={handleInputChange}
                    />
                    {formErrors.name && (
                      <span className="error">{formErrors.name}</span>
                    )}
                  </div>
                  <div className="campo-datos">
                    <label htmlFor="email" className="label-contact-datos">
                      {language ? json.En.email : json.Es.email}
                    </label>
                    <br />
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="campo-contact-datos"
                      value={formValues.email}
                      onChange={handleInputChange}
                    />
                    {formErrors.email && (
                      <span className="error">{formErrors.email}</span>
                    )}
                  </div>
                  <div className="campo-datos">
                    <label htmlFor="title" className="label-contact-datos">
                      {language ? json.En.title : json.Es.title}
                    </label>
                    <br />
                    <select
                      id="title"
                      name="title"
                      className="campo-contact-datos"
                      value={formValues.title}
                      onChange={handleInputChange}
                    >
                      <option value="app">
                        {language ? json.En.appMobile : json.Es.appMobile}
                      </option>
                      <option value="web">
                        {language ? json.En.web : json.Es.web}
                      </option>
                      <option value="solution">
                        {language ? json.En.solition : json.Es.solition}
                      </option>
                      <option value="adata">
                        {language ? json.En.data : json.Es.data}
                      </option>
                    </select>
                    {formErrors.title && (
                      <span className="error">{formErrors.title}</span>
                    )}
                  </div>
                  <div className="campo-datos">
                    <label htmlFor="message" className="label-contact-datos">
                      {language ? json.En.message : json.Es.message}
                    </label>
                    <br />
                    <textarea
                      id="message"
                      name="message"
                      rows="10"
                      cols="30"
                      className="campo-contact-datos-mensaje"
                      value={formValues.message}
                      onChange={handleInputChange}
                    ></textarea>
                    {formErrors.message && (
                      <span className="error">{formErrors.message}</span>
                    )}
                  </div>
                  <div className="campo-datos">
                    <button
                      type="submit"
                      className="enviar-datos"
                      style={{ cursor: "pointer" }}
                    >
                      {language ? json.En.send : json.Es.send}
                    </button>
                  </div>
                </form>
              </article>
            </article>
          </article>
          <section className="contenido-clientes">
            <h2>{language ? json.En.h2Clients1 : json.Es.h2Clients1}</h2>
            <article className="clientes">
              <img
                src="css/images/cliente01_.png"
                className="cliente-logo"
                alt="walliasaba"
              />
              <img
                src="css/images/cliente10.png"
                className="cliente-logo"
                alt="walliataf"
              />
              <img
                src="css/images/cliente03_.png"
                className="cliente-logo"
                alt="walliapetco"
              />
              <img
                src="css/images/cliente09.png"
                className="cliente-logo"
                alt="walliaguess"
              />
              <img
                src="css/images/cliente05_.png"
                className="cliente-logo"
                alt="walliashake"
              />
              <img
                src="css/images/cliente06_.png"
                className="cliente-logo"
                alt="walliacalvinklein"
              />
              <img
                src="css/images/cliente07_.png"
                className="cliente-logo"
                alt="walliatommy"
              />
              <img
                src="css/images/cliente08_.png"
                className="cliente-logo"
                alt="walliabath"
              />
            </article>
          </section>
        </section>
      </section>
    </>
  );
}
